"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */

exports.getArrayIfSingleItem = function (mayBeArray) {
  return Array.isArray(mayBeArray) ? mayBeArray : [mayBeArray];
};